export const iconFontAwesomePhotosImagesCamera = (
	<i className="fa-solid fa-camera"></i>
);
